import axios from "@/axios";
import store from "../store/index";
import dc from "./DataChk";

let items = [];
let tempItems = [];

export default {
	async getPageItems(url, search, page, isModal) {
		let res = [];
		if (!this.nullChk(isModal)) {
			items = tempItems;
		}

		const pagingInfo = page;
		const searchInfo = search;

		if (
			pagingInfo.type === 1 ||
			pagingInfo.type === 3 ||
			this.getRange(pagingInfo.currentPage + pagingInfo.pageNum, pagingInfo.limitNum) !==
			this.getRange(pagingInfo.prePage, pagingInfo.limitNum)
		) {
			const cp = pagingInfo.currentPage === -1 ? 1 : pagingInfo.currentPage;
			const range = this.getRange(cp + pagingInfo.pageNum, pagingInfo.limitNum);
			
			searchInfo.skipCount = range * Number(pagingInfo.perPage) * pagingInfo.limitNum;
			searchInfo.limit = Number(pagingInfo.perPage) * pagingInfo.limitNum + 1;
			searchInfo.nextKey = "";
			searchInfo.preKey = "";
			
			if (pagingInfo.type === 1) {
				pagingInfo.currentPage = -1;
				pagingInfo.pageNum = 0;
				searchInfo.skipCount = 0;
			}

			if (pagingInfo.type === 3) {
				const page1 = pagingInfo.currentPage + pagingInfo.pageNum - range * 10;
				const page2 = Math.ceil(this.getRows() / Number(pagingInfo.perPage));

				if (this.getRows() < Number(pagingInfo.perPage) * pagingInfo.limitNum && page1 > page2) {
					pagingInfo.currentPage = page2;
				}
				searchInfo.changePerpage = true;
			}

			const totalItems = Number(String(pagingInfo.total).replace(/,/g, "")) || 0;
			const totalPages = Math.ceil(totalItems / Number(pagingInfo.perPage));
			const currentPageNum = cp + pagingInfo.pageNum;

			if (pagingInfo.type !== 1 && currentPageNum > pagingInfo.prePage) {
				// 다음 페이지용 nextKey (마지막 페이지는 제외)
				if (currentPageNum < totalPages) {
					searchInfo.nextKey = items[Number(pagingInfo.perPage) * pagingInfo.limitNum - 1]?.id || "";
				} else {
					searchInfo.nextKey = "";
				}
			} else if (pagingInfo.type !== 1 && currentPageNum < pagingInfo.prePage) {
				// 이전 페이지용 preKey (첫 페이지는 제외)
				if (currentPageNum > 1) {
					searchInfo.preKey = items[0]?.id || "";
				} else {
					searchInfo.preKey = "";
				}
			}
			res = await this.request(url, searchInfo, pagingInfo, isModal);
		} else {
			res = this.changeViewItems(pagingInfo);
		}
		return res;
	},
	nullChk(val) {
		if (val !== undefined && val !== null) {
			return true;
		}
		return false;
	},

	async request(url, search, pagingInfo, isModal) {
		const searchInfo = search;
		store.commit("loading/SHOW_LOADING");
		return axios
			.post(url, searchInfo)
			.then((response) => {
				let viewItems = [];
				if (response.data.resType === "RES_OK" && response.data.resList.length > 0) {
					items = response.data.resList;
					if (!this.nullChk(isModal)) {
						tempItems = items;
					}
					viewItems = this.changeViewItems(pagingInfo);
					if (pagingInfo.type === 3) {
						searchInfo.changePerpage = false;
					}
				}

				store.commit("loading/HIDE_LOADING");
				// callback(viewItems);
				return viewItems;
			})
			.catch((error) => {
				console.log(error);
				store.commit("loading/HIDE_LOADING");
			});
	},

	changeViewItems(page) {
		const pagingInfo = page;
		const cp = pagingInfo.currentPage === -1 ? 1 : pagingInfo.currentPage;

		const range = this.getRange(cp + pagingInfo.pageNum, pagingInfo.limitNum);
		//  Math.floor(parseFloat((pagingInfo.currentPage / 10 - 0.1).toFixed(1)));

		const page1 = cp + pagingInfo.pageNum - range * pagingInfo.limitNum;
		const page2 = Math.ceil(this.getRows() / Number(pagingInfo.perPage));

		let currentPage = page1;
		let viewItems = [];
		if (this.getRows() < Number(pagingInfo.perPage) * pagingInfo.limitNum && page1 > page2) {
			currentPage = page2;
		}
		viewItems = items.slice(
			(currentPage - 1) * Number(pagingInfo.perPage),
			(currentPage - 1) * Number(pagingInfo.perPage) + Number(pagingInfo.perPage)
		);

		pagingInfo.prePage = cp + pagingInfo.pageNum;
		return viewItems;
	},

	getRange(page, limitNum) {
		return Math.floor(parseFloat((page / limitNum - 0.1).toFixed(1)));
	},

	getRows() {
		return items.length;
	},

	async listPaging(inData, pagingInfo) {
		const cp = pagingInfo.currentPage === -1 ? 1 : pagingInfo.currentPage;

		const page1 = cp + pagingInfo.pageNum;
		const page2 = Math.ceil(this.getRows() / Number(pagingInfo.perPage));

		let currentPage = page1;
		let viewItems = [];
		if (this.getRows() < Number(pagingInfo.perPage) * pagingInfo.limitNum && page1 > page2) {
			currentPage = page2;
		}
		viewItems = inData.slice(
			(currentPage - 1) * Number(pagingInfo.perPage),
			(currentPage - 1) * Number(pagingInfo.perPage) + Number(pagingInfo.perPage)
		);

		pagingInfo.prePage = cp + pagingInfo.pageNum;
		return viewItems;
	},

	async total(url, search) {
		const searchInfo = search;
		return axios
			.post(url, searchInfo)
			.then((response) => {
				let res = -1;
				if (response.data.resType === "RES_OK") {
					res = dc.commaMaker(response.data.resMsg);
				}
				return res;
			})
			.catch((error) => {
				console.log(error);
			});
	},
};
